import type { CreateMessageParams } from 'bundles/enterprise-admin-messages/types';
import type { CreateSkillsMessageParams } from 'bundles/enterprise-admin-skills/utils/apiTypes';

export const setCreateMessageParams = (actionContext: $TSFixMe, payload: { params: CreateMessageParams }) => {
  const { params } = payload;
  actionContext.dispatch('UPDATE_CREATE_MESSAGE_PARAMS', { params });
};

export const clearCreateMessageParams = (actionContext: $TSFixMe) => {
  actionContext.dispatch('CLEAR_CREATE_MESSAGE_PARAMS');
};

export const setCreateSkillsMessageParams = (
  actionContext: $TSFixMe,
  payload: { params: CreateSkillsMessageParams }
) => {
  const { params } = payload;
  actionContext.dispatch('UPDATE_CREATE_SKILLS_MESSAGE_PARAMS', { params });
};

export const resetAllMessageParams = (actionContext: $TSFixMe) => {
  actionContext.dispatch('RESET_PARAMS');
};
